import React, { useState, useEffect } from "react";
import { Table, Button, Container, Modal, Form, Pagination, Spinner, Card, Row, Col, Alert, Badge } from "react-bootstrap";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import ErrorModal from "./ErrorModal";
import { CSVLink } from "react-csv";
import { buildPublicRedeemUrl } from "../utils/publicRedeemUrl";

const tariffNameOf = (batch) => batch.tariff_name || batch.t_tariffs?.tariff_name || "";

const voucherForValue = (batch) =>
  ["HUMAN", "AI", "BOTH"].includes(batch.participant_type) ? batch.participant_type : "HUMAN";

const voucherForLabel = (value) => ({
  HUMAN: "Mensch",
  AI: "KI",
  BOTH: "Mensch & KI",
}[value] || "Mensch");

const BoardBatchcodes = () => {
  const [batchCode, setBatchCode] = useState([]);

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedBatchCode, setSelectedBatchCode] = useState(null);
  const [apierrors, setApiErrors] = useState("");
  const [filterTerm, setFilterTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: 'batch_code_id', direction: "asc" });
  const [loading, setLoading] = useState(false); // <-- DIESE ZEILE WIEDER HINZUFÜGEN
  const [showErrorModal, setShowErrorModal] = useState(false);


  const [errorCode, setApiErrorCode] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Angepasst auf 10 pro Seite
  const [tariffDetails, setTariffDetails] = useState(null);
  const [batchOrderDetails, setBatchOrderDetails] = useState(null);
  const [mainVoDetails, setMainVoDetails] = useState(null);
  const [subVoDetails, setSubVoDetails] = useState(null);
  const [admDetails, setAdmDetails] = useState(null);
  const [customerDetails, setCustomerDetails] = useState(null);

  // --- Filter & Aktionsbuendel (Mehrfachauswahl Produkt/Dienst + Charge) ---
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedBatchNames, setSelectedBatchNames] = useState([]);
  const [selectedTariffNames, setSelectedTariffNames] = useState([]);
  const [selectedParticipantTypes, setSelectedParticipantTypes] = useState([]);
  const [serviceSearch, setServiceSearch] = useState("");
  const [batchSearch, setBatchSearch] = useState("");
  const [tariffSearch, setTariffSearch] = useState("");
  const [participantTypeSearch, setParticipantTypeSearch] = useState("");
  const [bulkBusy, setBulkBusy] = useState(false);
  const [bulkResult, setBulkResult] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingAction, setPendingAction] = useState(null); // "block" | "delete"
  const [masterBatchNames, setMasterBatchNames] = useState([]);

  const loadBatchCodes = () => {
    setLoading(true); // Lade-Spinner aktivieren
    return UserService.getBatchBoard()
      .then((response) => {
        setBatchCode(response.data);
      })
      .catch((error) => {
        if (error.response) {
          setApiErrors(`Fehler: ${error.name} - ${error.response.data.message}-${error.code}`);
          setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
        } else if (error.request) {
          setApiErrors("Fehler: Keine Antwort vom Server erhalten.");
          setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
        } else {
          setApiErrors(`Fehler: ${error.message}`);
          setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
        }
        setBatchCode([]);
        if (error.response?.status === 401) {
          EventBus.dispatch("logout");
        }
      })
      .finally(() => {
        setLoading(false); // Lade-Spinner in jedem Fall deaktivieren
      });
  };

  useEffect(() => {
    loadBatchCodes();
    UserService.getBatchNames()
      .then((response) => {
        setMasterBatchNames(Array.isArray(response.data) ? response.data : []);
      })
      .catch(() => {
        setMasterBatchNames([]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Wechselt die Produkt/Dienst-Auswahl, werden Charge-Auswahlen entfernt,
  // die nicht mehr zur (kaskadierenden) Liste passen.
  useEffect(() => {
    if (selectedServices.length === 0) return;
    const rows = (Array.isArray(batchCode) ? batchCode : []).filter((vo) => {
      const raw = vo.service_name;
      const v = raw === null || raw === undefined || raw === "" ? "" : String(raw);
      return selectedServices.includes(v);
    });
    const available = new Set(
      rows.map((vo) => {
        const raw = vo.batch_name;
        return raw === null || raw === undefined || raw === "" ? "" : String(raw);
      })
    );
    setSelectedBatchNames((prev) => prev.filter((v) => available.has(v)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedServices, batchCode]);

    // --- FÜGE DEN NEUEN CODE-BLOCK GENAU HIER EIN ---
  useEffect(() => {
    // Alle Detail-States zurücksetzen, wenn ein neuer Code ausgewählt wird
    setTariffDetails(null);
    setBatchOrderDetails(null);
    setMainVoDetails(null);
    setSubVoDetails(null);
    setAdmDetails(null);
    setCustomerDetails(null);

    if (selectedBatchCode) {
      // HINWEIS: Die folgenden Service-Funktionen müssen in 'user.service.js' existieren!

      // 1. Lade Tarifdetails
      if (selectedBatchCode.tariff_id) {
        UserService.getTariffById(selectedBatchCode.tariff_id)
          .then(response => setTariffDetails(response.data))
          .catch(error => console.error("Fehler beim Laden der Tarifdetails:", error));
      }

      // 2. Lade Bestelldetails (um den Käufer zu finden)
      if (selectedBatchCode.batch_id) {
        UserService.getBatchOrderByBatchId(selectedBatchCode.batch_id)
          .then(response => {
            const order = response.data;
            setBatchOrderDetails(order);
            // 2.1 Lade die Details des Käufers basierend auf Typ und ID
            if (order && order.buyer_id && order.buyer_type) {
              if (order.buyer_type === 'sub_vo') {
                UserService.getSubVoById(order.buyer_id) // Annahme: getSubVoById existiert
                  .then(res => setCustomerDetails(res.data))
                  .catch(err => console.error("Käufer (SubVO) nicht gefunden:", err));
              }
              // Hier weitere Abfragen für 't_ads', 't_customer' etc. hinzufügen
            }
          })
          .catch(error => console.error("Fehler beim Laden der Bestelldetails:", error));
      }

      // 3. Lade zugeordnete MainVO-Details
      if (selectedBatchCode.main_vo_id) {
        UserService.getMainVoById(selectedBatchCode.main_vo_id) // Annahme: getMainVoById existiert
          .then(response => setMainVoDetails(response.data))
          .catch(error => console.error("MainVO-Details nicht gefunden:", error));
      }

      // 4. Lade zugeordnete SubVO-Details
      if (selectedBatchCode.sub_vo_id) {
        UserService.getSubVoById(selectedBatchCode.sub_vo_id) // Annahme: getSubVoById existiert
          .then(response => setSubVoDetails(response.data))
          .catch(error => console.error("SubVO-Details nicht gefunden:", error));
      }

      // 5. Lade zugeordnete ADM-Details
      if (selectedBatchCode.user_id) {
        UserService.getAdById(selectedBatchCode.user_id) // Annahme: getAdById existiert
          .then(response => setAdmDetails(response.data))
          .catch(error => console.error("ADM-Details nicht gefunden:", error));
      }
    }
  }, [selectedBatchCode]);
  // --- ENDE DES NEUEN CODE-BLOCKS ---

  const handleShowDetails = (batch) => {
    setSelectedBatchCode(batch);
    setShowDetailsModal(true);
  };
  const handleCloseDetailsModal = () => setShowDetailsModal(false);

  const csvData = Array.isArray(batchCode) ? batchCode.map(item => ({
    ID: item.batch_code_id,
    "Batch-Name": item.batch_name,
    "QR-Code": item.in_url_code_generated,
    PIN: item.pin,
    "Service-Name": item.service_name,
    "Tarif-ID": item.tariff_id,
    Tarifname: tariffNameOf(item),
    "Voucher für": voucherForLabel(voucherForValue(item)),
    "Gültig von": item.batch_validity_from_date,
    "Gültig bis": item.batch_validity_until_date,
  })) : [];

  const allBatches = Array.isArray(batchCode) ? batchCode : [];

  const valueOf = (vo, field) => {
    if (field === "tariff_name") return String(tariffNameOf(vo));
    if (field === "participant_type") return voucherForValue(vo);
    const raw = vo[field];
    return raw === null || raw === undefined || raw === "" ? "" : String(raw);
  };

  // Eindeutige Auswahlwerte mit Anzahl je Facette (NULL/leer -> "(ohne)").
  const buildOptions = (field, rows) => {
    const counts = new Map();
    rows.forEach((vo) => {
      const value = valueOf(vo, field);
      counts.set(value, (counts.get(value) || 0) + 1);
    });
    return Array.from(counts.entries())
      .map(([value, count]) => ({ value, count }))
      .sort((a, b) => a.value.localeCompare(b.value, "de"));
  };

  const serviceOptions = buildOptions("service_name", allBatches);
  const tariffNameOptions = buildOptions("tariff_name", allBatches);
  const participantTypeOptions = buildOptions("participant_type", allBatches);

  const batchSourceRows =
    selectedServices.length === 0
      ? allBatches
      : allBatches.filter((vo) => selectedServices.includes(valueOf(vo, "service_name")));
  const codeBasedOptions = buildOptions("batch_name", batchSourceRows);

  const batchNameOptions = (() => {
    const merged = new Map(codeBasedOptions.map((o) => [o.value, o.count]));
    const filteredMasters = selectedServices.length === 0
      ? masterBatchNames
      : masterBatchNames.filter((m) => {
          const svcName = m.t_services?.service_name || "";
          return selectedServices.includes(svcName);
        });
    filteredMasters.forEach((m) => {
      const name = m.batch_name || "";
      if (!merged.has(name)) {
        merged.set(name, 0);
      }
    });
    return Array.from(merged.entries())
      .map(([value, count]) => ({ value, count }))
      .sort((a, b) => a.value.localeCompare(b.value, "de"));
  })();

  // Eine Zeile passt zu den gewaehlten Facetten (OR innerhalb, AND zwischen Facetten).
  const facetMatches = (vo) =>
    (selectedServices.length === 0 || selectedServices.includes(valueOf(vo, "service_name"))) &&
    (selectedBatchNames.length === 0 || selectedBatchNames.includes(valueOf(vo, "batch_name"))) &&
    (selectedTariffNames.length === 0 || selectedTariffNames.includes(valueOf(vo, "tariff_name"))) &&
    (selectedParticipantTypes.length === 0 || selectedParticipantTypes.includes(valueOf(vo, "participant_type")));

  const anyFacetSelected = selectedServices.length > 0 || selectedBatchNames.length > 0 ||
    selectedTariffNames.length > 0 || selectedParticipantTypes.length > 0;

  // Zielmenge des Aktionsbuendels = alle Codes, die zur Facetten-Auswahl passen.
  const targetBatches = anyFacetSelected ? allBatches.filter(facetMatches) : [];
  const targetIds = targetBatches.map((vo) => vo.batch_code_id);

  // Tabelle zeigt Facetten-Treffer UND Freitext-Treffer.
  const filteredBatchCodes = allBatches.filter(
    (vo) =>
      facetMatches(vo) &&
      [...Object.values(vo), tariffNameOf(vo), voucherForLabel(voucherForValue(vo))].some((value) =>
        String(value).toLowerCase().includes(filterTerm.toLowerCase())
      )
  );

  const toggleValue = (list, setList, value) => {
    setList(list.includes(value) ? list.filter((v) => v !== value) : [...list, value]);
    setCurrentPage(1);
  };

  const clearFacets = () => {
    setSelectedServices([]);
    setSelectedBatchNames([]);
    setSelectedTariffNames([]);
    setSelectedParticipantTypes([]);
    setServiceSearch("");
    setBatchSearch("");
    setTariffSearch("");
    setParticipantTypeSearch("");
    setCurrentPage(1);
  };

  const askBulkAction = (action) => {
    setBulkResult(null);
    if (targetIds.length === 0) {
      setApiErrors("Bitte zuerst mindestens einen Filter auswählen.");
      setApiErrorCode("Keine Auswahl");
      setShowErrorModal(true);
      return;
    }
    setPendingAction(action);
    setShowConfirm(true);
  };

  const handleConfirmBulkAction = () => {
    if (!pendingAction || targetIds.length === 0) {
      setShowConfirm(false);
      return;
    }
    setBulkBusy(true);
    UserService.bulkBatchAction(pendingAction, targetIds)
      .then((response) => {
        setBulkResult(response.data?.message || "Aktion ausgefuehrt.");
        setShowConfirm(false);
        setPendingAction(null);
        return loadBatchCodes();
      })
      .catch((error) => {
        const msg = error.response?.data?.message || error.message || "Unbekannter Fehler";
        setApiErrors(`Fehler beim Aktionsbuendel: ${msg}`);
        setApiErrorCode(`Fehler: ${error.code || ""}`);
        setShowErrorModal(true);
        setShowConfirm(false);
        if (error.response?.status === 401) {
          EventBus.dispatch("logout");
        }
      })
      .finally(() => {
        setBulkBusy(false);
      });
  };

  // Wiederverwendbare, durchsuchbare Mehrfachauswahl.
  const renderFacet = (title, options, selected, setSelected, search, setSearch, labelForValue = (value) => value) => {
    const filteredOptions = options.filter((opt) => {
      const label = opt.value === "" ? "(ohne)" : labelForValue(opt.value);
      return label.toLowerCase().includes(search.toLowerCase());
    });
    return (
      <Card className="h-100">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <strong>{title}</strong>
          <Badge bg={selected.length ? "primary" : "secondary"}>{selected.length} gewaehlt</Badge>
        </Card.Header>
        <Card.Body>
          <Form.Control
            type="text"
            size="sm"
            placeholder="In Auswahl suchen..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="mb-2"
          />
          <div style={{ maxHeight: "180px", overflowY: "auto", paddingLeft: "0.75rem" }}>
            {filteredOptions.length === 0 ? (
              <small className="text-muted">Keine Eintraege.</small>
            ) : (
              filteredOptions.map((opt) => {
                const label = opt.value === "" ? "(ohne)" : labelForValue(opt.value);
                const safeId = `${title}-${opt.value || "empty"}`.replace(/[^A-Za-z0-9_-]+/g, "-");
                return (
                  <Form.Check
                    key={opt.value || "__empty__"}
                    type="checkbox"
                    id={safeId}
                    label={`${label} (${opt.count})`}
                    checked={selected.includes(opt.value)}
                    onChange={() => toggleValue(selected, setSelected, opt.value)}
                  />
                );
              })
            )}
          </div>
        </Card.Body>
      </Card>
    );
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedBatchCodes = [...filteredBatchCodes].sort((a, b) => {
    const virtualField = sortConfig.key === "tariff_name" || sortConfig.key === "participant_type";
    const aValue = virtualField ? valueOf(a, sortConfig.key) : (a[sortConfig.key] ?? '');
    const bValue = virtualField ? valueOf(b, sortConfig.key) : (b[sortConfig.key] ?? '');
    if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentBatches = sortedBatchCodes.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredBatchCodes.length / itemsPerPage);

  const handleCloseErrorModal = () => setShowErrorModal(false);

  // Helper zum Anzeigen von Ja/Nein statt true/false
  const formatBoolean = (value) => value ? 'Ja' : 'Nein';

  return (
    <Container fluid>
      <h1 className="mt-5">Chargencodes Übersicht</h1>
      <ErrorModal show={showErrorModal} handleClose={handleCloseErrorModal} errorCode={errorCode} errorMessage={apierrors} />

      <Card className="mt-3 mb-3 border-primary">
        <Card.Header className="bg-primary text-white">
          <strong>Filter</strong>
        </Card.Header>
        <Card.Body>
          <Row className="g-3">
            <Col xs={12} md={6} className="mb-3 mb-md-0">
              {renderFacet("Produkt / Dienst", serviceOptions, selectedServices, setSelectedServices, serviceSearch, setServiceSearch)}
            </Col>
            <Col xs={12} md={6}>
              {renderFacet("Charge / Batch-Name", batchNameOptions, selectedBatchNames, setSelectedBatchNames, batchSearch, setBatchSearch)}
            </Col>
            <Col xs={12} md={6}>
              {renderFacet("Tarifname", tariffNameOptions, selectedTariffNames, setSelectedTariffNames, tariffSearch, setTariffSearch)}
            </Col>
            <Col xs={12} md={6}>
              {renderFacet("Voucher für", participantTypeOptions, selectedParticipantTypes, setSelectedParticipantTypes, participantTypeSearch, setParticipantTypeSearch, voucherForLabel)}
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mb-4 border-danger">
        <Card.Header className="bg-light">
          <strong>Aktionsbündel</strong>
        </Card.Header>
        <Card.Body>
          <div className="d-flex flex-wrap align-items-center gap-2">
            <span className="me-2">
              Betroffene Codes:{" "}
              <Badge bg={targetIds.length ? "primary" : "secondary"}>{targetIds.length}</Badge>
            </span>
            <Button
              variant="warning"
              disabled={bulkBusy || targetIds.length === 0}
              onClick={() => askBulkAction("block")}
              className="me-2"
            >
              Ausgewählte sperren
            </Button>
            <Button
              variant="danger"
              disabled={bulkBusy || targetIds.length === 0}
              onClick={() => askBulkAction("delete")}
              className="me-2"
            >
              Ausgewählte löschen
            </Button>
            <Button
              variant="outline-secondary"
              disabled={bulkBusy || !anyFacetSelected}
              onClick={clearFacets}
            >
              Auswahl zurücksetzen
            </Button>
            {bulkBusy && <Spinner animation="border" size="sm" className="ms-2" />}
          </div>

          {!anyFacetSelected && (
            <small className="text-muted d-block mt-2">
              Hinweis: Bitte mindestens einen Filter auswählen, um Aktionen auszuführen.
            </small>
          )}

          {bulkResult && (
            <Alert variant="info" className="mt-3 mb-0" dismissible onClose={() => setBulkResult(null)}>
              {bulkResult}
            </Alert>
          )}
        </Card.Body>
      </Card>

      <CSVLink data={csvData} filename="Chargencodes.csv" className="btn btn-info mr-2 mb-2">
        Daten exportieren
      </CSVLink>

      <Form.Group controlId="formBasicSearch" className="my-3">
        <Form.Control
          type="text"
          placeholder="Suchen..."
          value={filterTerm}
          onChange={(e) => setFilterTerm(e.target.value)}
        />
      </Form.Group>

      {loading && <Spinner animation="border" />}

      <Table striped bordered hover responsive className="mt-2">
        <thead>
          <tr>
            <th onClick={() => handleSort('in_url_code_generated_index_in_batch')} style={{ cursor: 'pointer' }}>
              Index-ID
            </th>
            <th onClick={() => handleSort('batch_id')} style={{ cursor: 'pointer' }}>
              Chargen-ID
            </th>
            <th onClick={() => handleSort('batch_name')} style={{ cursor: 'pointer' }}>
              Chargenname
            </th>
            <th>QR-Bild</th>

            <th onClick={() => handleSort('in_url_code_generated')} style={{ cursor: 'pointer' }}>
              QR-Code
            </th>
            <th onClick={() => handleSort('pin')} style={{ cursor: 'pointer' }}>
              NFC-Pin
            </th>
            <th onClick={() => handleSort('service_name')} style={{ cursor: 'pointer' }}>
              Service-Name
            </th>
            <th onClick={() => handleSort('tariff_id')} style={{ cursor: 'pointer' }}>
              Tarif-ID
            </th>
            <th onClick={() => handleSort('tariff_name')} style={{ cursor: 'pointer' }}>
              Tarifname
            </th>
            <th onClick={() => handleSort('participant_type')} style={{ cursor: 'pointer' }}>
              Voucher für
            </th>
            <th onClick={() => handleSort('batch_validity_from_date')} style={{ cursor: 'pointer' }}>
              Gültig von
            </th>
            <th onClick={() => handleSort('batch_validity_until_date')} style={{ cursor: 'pointer' }}>
              Gültig bis
            </th>
            <th>Aktionen</th>
          </tr>
        </thead>

        <tbody>
          {currentBatches.map((vo) => (
            <tr key={vo.batch_code_id}>
              <td>{vo.in_url_code_generated_index_in_batch}</td>
              <td>{vo.batch_id}</td>
              <td>{vo.batch_name}</td>
              <td>
                {vo.qr_code ? (
                  <a href={buildPublicRedeemUrl(vo.in_url_code_generated)} target="_blank" rel="noopener noreferrer">
                    {/* QR-Bild vergrößert */}
                    <img src={`data:image/png;base64,${vo.qr_code}`} alt="QR-Code" style={{ width: '80px', height: '80px' }} />
                  </a>
                ) : 'N/A'}
              </td>
              <td>{vo.in_url_code_generated}</td>
              <td>{vo.pin}</td>
              <td>{vo.service_name}</td>
              <td>{vo.tariff_id || '—'}</td>
              <td>{tariffNameOf(vo) || '—'}</td>
              <td>{voucherForLabel(voucherForValue(vo))}</td>
              <td>{new Date(vo.batch_validity_from_date).toLocaleDateString('de-DE')}</td>
              <td>{new Date(vo.batch_validity_until_date).toLocaleDateString('de-DE')}</td>
              <td>
                <Button variant="info" onClick={() => handleShowDetails(vo)}>Details</Button>
              </td>
            </tr>
          ))}
        </tbody>

      </Table>

      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item key={index} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>
            {index + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>




      <Modal show={showDetailsModal} onHide={handleCloseDetailsModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Chargencodes Details: {selectedBatchCode?.batch_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedBatchCode ? (
            <div>
              {/* Gruppe 1: Stammdaten */}
              <h5>Stammdaten</h5>
              <Table bordered striped size="sm">
                <tbody>
                  <tr><td><strong>ID (Einzel-Code)</strong></td><td>{selectedBatchCode.batch_code_id}</td></tr>
                  <tr><td><strong>Index im Batch</strong></td><td>{selectedBatchCode.in_url_code_generated_index_in_batch}</td></tr>
                  <tr><td><strong>Chargen-ID (Gruppe)</strong></td><td>{selectedBatchCode.batch_id}</td></tr>
                  <tr><td><strong>Chargenname</strong></td><td>{selectedBatchCode.batch_name}</td></tr>
                  <tr><td><strong>Anzahl in der Charge</strong></td><td>{selectedBatchCode.batch_quantity}</td></tr>
                </tbody>
              </Table>

              {/* Gruppe 2: Gültigkeit & Status */}
              <h5>Gültigkeit & Status</h5>
              <Table bordered striped size="sm">
                <tbody>
                  <tr><td><strong>Gültig von</strong></td><td>{new Date(selectedBatchCode.batch_validity_from_date).toLocaleDateString('de-DE')}</td></tr>
                  <tr><td><strong>Gültig bis</strong></td><td>{new Date(selectedBatchCode.batch_validity_until_date).toLocaleDateString('de-DE')}</td></tr>
                  <tr><td><strong>Nächste Abrechnung</strong></td><td>{selectedBatchCode.next_billing_date ? new Date(selectedBatchCode.next_billing_date).toLocaleDateString('de-DE') : 'N/A'}</td></tr>
                  <tr><td><strong>Abo-Status</strong></td><td>{selectedBatchCode.subscription_status || 'N/A'}</td></tr>
                  <tr><td><strong>Status-ID</strong></td><td>{selectedBatchCode.status_id}</td></tr>
                  <tr><td><strong>Demo Aktiviert</strong></td><td>{formatBoolean(selectedBatchCode.demo_is_activated)}</td></tr>
                </tbody>
              </Table>
              
              {/* Gruppe 3: Service & Tarif */}
              <h5>Service & Tarif</h5>
              <Table bordered striped size="sm">
                <tbody>
                  <tr><td><strong>Service-ID</strong></td><td>{selectedBatchCode.service_id}</td></tr>
                  <tr><td><strong>Service-Name</strong></td><td>{selectedBatchCode.service_name}</td></tr>
                  <tr><td><strong>Tarif-ID</strong></td><td>{selectedBatchCode.tariff_id}</td></tr>
                  <tr><td><strong>Tarif-Name</strong></td><td>{tariffNameOf(selectedBatchCode) || tariffDetails?.tariff_name || '...'}</td></tr>
                  <tr><td><strong>Voucher für</strong></td><td>{voucherForLabel(voucherForValue(selectedBatchCode))}</td></tr>
                  <tr><td><strong>Aktivierungsgebühr</strong></td><td>{tariffDetails ? `${tariffDetails.activation_fee_eur_net} €` : '...'}</td></tr>
                  <tr><td><strong>Betrag (Netto)</strong></td><td>{tariffDetails ? `${tariffDetails.amount_eur_net} €` : '...'}</td></tr>
                  <tr><td><strong>Abrechnungszeitraum</strong></td><td>{tariffDetails?.amount_period_net || '...'}</td></tr>
                  <tr><td><strong>Provisionstyp</strong></td><td>{tariffDetails?.provision_type || '...'}</td></tr>
                  <tr><td><strong>Bereichsgruppe</strong></td><td>{tariffDetails?.validity_area?.t_areas_group?.area_group_name || '...'}</td></tr>
                </tbody>
              </Table>
              
              {/* Gruppe 4: URLs, QR & NFC */}
              <h5>URLs, QR & NFC</h5>
              <Table bordered striped size="sm">
                <tbody>
                  <tr><td><strong>NFC-Pin</strong></td><td><strong>{selectedBatchCode.pin}</strong></td></tr>
                  <tr><td><strong>URL-Code</strong></td><td>{selectedBatchCode.in_url_code_generated}</td></tr>
                  <tr><td><strong>URL-Hash</strong></td><td>{selectedBatchCode.batch_url_hash}</td></tr>
                  <tr><td><strong>Service IN-URL</strong></td><td>{selectedBatchCode.service_in_url}</td></tr>
                  <tr><td><strong>Service OUT-URL</strong></td><td>{selectedBatchCode.service_out_url}</td></tr>
                  <tr><td><strong>Service IN-URL (komplett)</strong></td><td>{selectedBatchCode.service_in_url_with_in_url_code_generated}</td></tr>
                  <tr><td><strong>Service OUT-URL (individuell)</strong></td><td>{selectedBatchCode.service_out_url_with_out_url_code_individual}</td></tr>
                  <tr><td><strong>Service OUT-URL (Ort)</strong></td><td>{selectedBatchCode.service_out_url_with_place_id}</td></tr>
                  <tr><td><strong>Sichtbarer QR-Code</strong></td><td>{formatBoolean(selectedBatchCode.visible_qr_code)}</td></tr>
                </tbody>
              </Table>
              
              {/* Gruppe 5: Verkaufsstatus & Zuordnung */}
              <h5>Verkaufsstatus & Zuordnung</h5>
              <Table bordered hover size="sm">
                <tbody>
                  <tr><td><strong>Verkauft an (Typ)</strong></td><td>{batchOrderDetails?.buyer_type || 'Nicht verkauft'}</td></tr>
                  <tr><td><strong>Käufer</strong></td><td>{customerDetails?.company_name || batchOrderDetails?.buyer_id || 'N/A'}</td></tr>
                  <tr><td><strong>Verkaufsdatum</strong></td><td>{batchOrderDetails ? new Date(batchOrderDetails.order_date).toLocaleString('de-DE') : 'N/A'}</td></tr>
                  <tr><td><strong>Zugeordneter Überhändler</strong></td><td>{mainVoDetails?.company_name || selectedBatchCode.main_vo_id}</td></tr>
                  <tr><td><strong>Zugeordneter Wiederverkäufer</strong></td><td>{subVoDetails?.company_name || selectedBatchCode.sub_vo_id}</td></tr>
                  <tr><td><strong>Zugeordnete Vertriebspartner</strong></td><td>{admDetails?.company_name || selectedBatchCode.user_id}</td></tr>
                  <tr><td><strong>Zugeordneter Endkunde</strong></td><td>{customerDetails?.custumer_company_name || selectedBatchCode.customer_id}</td></tr>
                </tbody>
              </Table>

            </div>
          ) : (
            <p>Keine Daten zum Anzeigen.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDetailsModal}>Schließen</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showConfirm} onHide={() => !bulkBusy && setShowConfirm(false)} centered>
        <Modal.Header closeButton={!bulkBusy}>
          <Modal.Title>
            {pendingAction === "delete" ? "Codes löschen?" : "Codes sperren?"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {pendingAction === "delete" ? (
            <>
              <p>
                Es werden <strong>{targetIds.length}</strong> ausgewählte Code(s) gelöscht.
              </p>
              <Alert variant="warning" className="mb-0">
                Verkaufte oder bereits eingelöste Codes sind geschützt und werden
                automatisch übersprungen (nur „Sperren“ ist dort möglich).
              </Alert>
            </>
          ) : (
            <p>
              Es werden <strong>{targetIds.length}</strong> ausgewählte Code(s) gesperrt
              (Status „REVOKED“, Abo „cancelled“). voicetreff verweigert dann den Zugang.
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" disabled={bulkBusy} onClick={() => setShowConfirm(false)}>
            Abbrechen
          </Button>
          <Button
            variant={pendingAction === "delete" ? "danger" : "warning"}
            disabled={bulkBusy}
            onClick={handleConfirmBulkAction}
          >
            {bulkBusy ? "Wird ausgeführt..." : pendingAction === "delete" ? "Endgültig löschen" : "Jetzt sperren"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default BoardBatchcodes;
